import React from "react";
import Sidebar from "../components/UserSidebar";
import ProfileHeader from "../components/ProfileHeader";
import ComplaintStatus from "../components/ComplaintStatus";

const UserComplaintStatus = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ProfileHeader />
        <div style={{ padding: "20px", flex: 1 }}>
          <ComplaintStatus />
        </div>
      </div>
    </div>
  );
};

export default UserComplaintStatus;
